export const SHOW_TAKE_SNAPSHOT_MODAL = 'SHOW_TAKE_SNAPSHOT_MODAL';
export const CLOSE_TAKE_SNAPSHOT_MODAL = 'CLOSE_TAKE_SNAPSHOT_MODAL';
